import { gql } from 'graphql-tag';
import { useMeContext } from '~/modules/me/useMeContext';

export const PTI_INTROSPECTION_QUERY = gql`
  query getPtiDtmIntrospection {
    __type(name: "PTI_DtmSessionMetadata") {
      name
    }
  }
`;

export const DTM_SESSION_METADATA_QUERY = gql`
  query getDtmSessionMetadata {
    getDtmSessionMetadata {
      session {
        clientId
      }
    }
  }
`;

export const useIsPtiEnabled = (): boolean => {
  const me = useMeContext();

  return Boolean(me?.isPtiEnabled);
};
